import PropTypes from 'prop-types'

// Internal components
import LazyImage from '../LazyImage/LazyImage'

const SponsorBlock = (props) => {
  const { heading, images } = props

  return (
    <div className="SponsorBlock">
      {heading && <h3 className="SponsorBlock-heading">{heading}</h3>}
      <ul className="SponsorBlock-list">
        {images &&
          images.map((sponsorImage, index) => {
            return (
              <li className="SponsorBlock-item" key={`SponsorBlock-item--${index}`}>
                <div className="SponsorBlock-imageWrapper">
                  {sponsorImage.linkItem.url ? (
                    <a
                      className="SponsorBlock-link"
                      href={sponsorImage.linkItem.url || '#'}
                      target={sponsorImage.linkItem.target}
                      rel="noreferrer"
                    >
                      {sponsorImage.imageItem && sponsorImage.imageItem.length > 0 && (
                        <LazyImage
                          image={sponsorImage.imageItem[0]}
                          modifiers={['LazyImage--sponsorBlock']}
                          alt={sponsorImage.labelItem}
                        />
                      )}
                    </a>
                  ) : (
                    sponsorImage.imageItem &&
                    sponsorImage.imageItem.length > 0 && (
                      <LazyImage
                        image={sponsorImage.imageItem[0]}
                        modifiers={['LazyImage--sponsorBlock']}
                        alt={sponsorImage.labelItem}
                      />
                    )
                  )}
                </div>
              </li>
            )
          })}
      </ul>
    </div>
  )
}

export default SponsorBlock

SponsorBlock.propTypes = {
  images: PropTypes.array,
  heading: PropTypes.string
}
